import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormBroadcast, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { COUNTY_LIST_SEGMENT } from '@ptl/global-components';
import { MemberLookupResponse } from '../../../shared/components/interfaces/member-lookup-response.interface';
import { WhbCrosswalk } from '../../../shared/components/interfaces/member-lookup.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PrePopulatedDataStateStructure } from '../../../shared/components/configs/interfaces/prePopulatedDataStateStructure.interface';

@FormComponentLookup('common-member-lookup')
@Component({
    selector: 'app-common-form-member-lookup',
    templateUrl: './common-form-member-lookup.component.html',
    styleUrls: ['./common-form-member-lookup.component.scss'],
    standalone: false
})
export class CommonFormMemberLookupComponent extends FormEntryComponentClass {

  isMemberValid: boolean = false;
  baseEvent: FormBroadcast;
  zipSegment: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.commonInit();

    const reducerUtilityService = this.injector.get(ReducerUtilityService);
    const prePopulateData: PrePopulatedDataStateStructure = reducerUtilityService.getState('PrePopulateData');
    this.isMemberValid = !!prePopulateData?.prepopulatedFields?.memberLookup?.BIRTHDATE;
  }

  ngAfterViewInit(): void {
    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
    
    formControl.setValidators((control: AbstractControl) => {
      return this.isMemberValid ? null : {'invalidMemberInfo': true};
    });

    formControl.updateValueAndValidity();
    this.subscribeToFormStream(this.entry.base.formListeners);
  }

  /* Common features of the member lookup to control form validity and broadcast changes */
  commonInit() {
    this.baseEvent = {
      formControlName: this.entry.formControlAttributes.formControlName,
      helperId: null,
      type: 'valueChange',
      value: null
    };

    this.zipSegment = this.entry?.custom?.zipSegment ? this.entry.custom.zipSegment : COUNTY_LIST_SEGMENT.SENIOR;
  }

  onMemberLookupResponse(memberLookupRes: MemberLookupResponse): void {
    if (memberLookupRes.isLoading) {
      this.baseEvent.value = 'clear';
      this.formStreamTrigger.triggerFormStream(this.baseEvent);
    }
    else if (memberLookupRes.memberFound && memberLookupRes.enableNext) {
      this.baseEvent.value = 'reset';
      this.formStreamTrigger.triggerFormStream(this.baseEvent);
      this.isMemberValid = true;
    }
    else {
      this.isMemberValid = false;
    }

    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
    formControl.updateValueAndValidity();
  }

  onCrosswalkResponse(crosswalk: WhbCrosswalk): void {
    // Available for child components to extend
  }
}
